import { SALARY_ISSUE_TYPES, ServerSalaryIssueType } from '@expane/data'

export const getServiceSalaryIssueTotalSum = (salaryIssue: ServerSalaryIssueType) => {
  if (
    salaryIssue.type === SALARY_ISSUE_TYPES.service ||
    salaryIssue.type === SALARY_ISSUE_TYPES.quickSaleService
  )
    return salaryIssue.value
  // если сумма зп зависит от реализованной стоимости то возвращаем ее
  // если оплаты нет то считаем по запасной формуле и считаем это значение
  if (salaryIssue.type === SALARY_ISSUE_TYPES.serviceWithActualSoldPrice) {
    if (salaryIssue.valueWhenDependentOnRealized) return salaryIssue.valueWhenDependentOnRealized
    else return salaryIssue.value
  } else return 0
}
